export default __webpack_public_path__ + "static/media/play_icon_big.3bad60f4.svg";